import { Component, Input } from '@angular/core';

import { ClaimService } from '../../../services/claim.service';
import { lastValueFrom } from 'rxjs/internal/lastValueFrom';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { PlatformsService } from '../../../../../core/data/services/platforms.service';

@Component({
  selector: 'app-claim-rate',
  imports: [],
  templateUrl: './claim-rate.component.html',
  styleUrl: './claim-rate.component.css',
})
export class ClaimRateComponent {
  @Input() claimId: string = '';
  stars: number[] = [1, 2, 3, 4, 5];
  selectedRating: number = 5; // First star always selected by default

  constructor(
    private claimService: ClaimService,
    private router: Router,
    private location: Location,
    private platformService: PlatformsService,
  ) { }

  selectRating(rating: number) {
    this.selectedRating = rating;
  }

  rateClaim() {
    lastValueFrom(this.claimService.rate(this.claimId, this.selectedRating));
    if (this.platformService.isIOs() || this.platformService.isEmbeddedApp()) {
      this.location.back();
      return;
    }
    this.router.navigate(['/claims']);
  }
}